import { addNotification } from './add-notification';
import { removeNotification } from './remove-notification';
export const addOrReplaceNotification = (notification) => {
    removeNotification(notification.id);
    addNotification(notification);
};
